export default __webpack_public_path__ + "static/media/icon_report_pressed.b994cf4e.svg";